var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50269 3.45005H8.50269V7.45005H4.55269V8.45005H8.50269V12.4501H9.50269V8.45005H13.5527V7.45005H9.50269V3.45005Z",
    fill: "#0076CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2498 12.6C12.8998 14.1 10.9998 14.95 8.9998 14.95C8.6998 14.95 8.3998 14.95 8.0998 14.9C4.9998 14.5 2.4498 11.95 2.0998 8.85001C1.8498 6.80002 2.4498 4.85001 3.7998 3.30002C5.1498 1.80002 7.0498 0.94998 9.0498 0.94998C9.3498 0.94998 9.64981 0.94998 9.94981 1C13.0498 1.39999 15.5998 3.94998 15.9498 7.05002C16.1998 9.10001 15.5998 11.05 14.2498 12.6ZM16.9498 6.94998C16.4998 3.39999 13.5998 0.5 10.0498 0.05002C9.6998 -7.13044e-10 9.3498 0 8.9998 0C4.2498 0 0.449805 4.14999 1.0498 9.05002C1.4998 12.6 4.3998 15.5 7.9498 15.95C8.2998 16 8.6498 16 8.9998 16C13.7498 15.95 17.5498 11.8 16.9498 6.94998Z",
    fill: "#0076CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.37d3eeed81a27dd6b5b7c13559641b3f.svg";
export { ForwardRef as ReactComponent };